module.exports = __webpack_public_path__ + "img/certif_012.74a5af8d.jpg";